// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import Filter from "../components/Marketfilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

function GeneralIndustries() {
     useGaspAnimations()

     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Food</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>   
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}

                                                   <img src="assets/images/Market-Images/02.webp" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="text-holder">
                                                <div className="title bdFadeUp">
                                                    <h2>Dairy Industry</h2>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>High-Performance Refrigeration for Dairy Processing and Cold Chain</span>
                                                    <p className="top">
                                                        Indus Refrigeration is a leading solution provider for the dairy industry, delivering energy-efficient and hygienic refrigeration systems that support every stage of dairy processing—from milk collection and chilling to storage and distribution. With decades of experience and engineering innovation, Indus ensures the highest standards of temperature control, product safety, and operational efficiency for dairy plants, cooperatives, and milk processing units.
                                                    </p>
                                                    <p>
                                                        Our customized refrigeration solutions help maintain the quality and freshness of milk and dairy products such as cheese, butter, paneer, curd, and ghee. Indus systems are designed to handle high-volume operations while complying with stringent industry standards such as BIS, FSSAI, and ISO.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for the Dairy Sector:</h2>
                                                </div>
                                               <p>Bulk Milk Coolers (BMCs) and Rapid Milk Chillers</p>

                                                <p>Chilling plants with glycol/brine-based systems</p>

                                                <p>Milk silos, cold rooms, and deep freezers for dairy product storage</p>

                                                <p>Energy-efficient ammonia and Freon-based refrigeration systems</p>

                                                <p>Packaged chillers and compressor systems for milk pasteurization and homogenization</p>

                                                <p>Turnkey solutions for dairy processing and storage plants, including design, installation, and maintenance</p>

                                                <p>With a deep understanding of dairy supply chain dynamics, Indus Refrigeration helps dairy enterprises minimize bacterial growth, reduce spoilage, and improve product consistency—ensuring your dairy products reach consumers in perfect condition.</p>
                                                  
                                            </div>    
                                        </div>
                                    </div>
                                
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default GeneralIndustries;


